import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import service from '../service';

export type GetMenusQuery = {
  name?: string;
  guid?: string;
};

export type ToastMenuItem = {
  guid: string;
  name: string;
  price: number | null;
  pricingStrategy?: 'BASE_PRICE' | 'OPEN_PRICE' | string;
  [k: string]: any;
};

export type ToastMenuGroup = {
  guid: string;
  name: string;
  menuGroups?: ToastMenuGroup[];
  menuItems?: ToastMenuItem[];
  [k: string]: any;
};

export type ToastMenu = {
  guid: string;
  name: string;
  menuGroups?: ToastMenuGroup[];
  [k: string]: any;
};

export type MenusResponse = {
  menus?: ToastMenu[];
  [k: string]: any;
};

type Params = {
  restaurantGuid: string;
  query?: GetMenusQuery;
  enabled?: boolean;
};

export function useToastMenus<TData = ToastMenu[], TError = unknown>(
  { restaurantGuid, query, enabled = true }: Params,
  options?: Omit<
    UseQueryOptions<ToastMenu[], TError, TData>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  const q = useQuery<ToastMenu[], TError, TData>({
    queryKey: [
      'toastMenus',
      restaurantGuid,
      query?.name ?? null,
      query?.guid ?? null,
    ],
    enabled: Boolean(restaurantGuid && enabled),
    queryFn: async () => {
      const res = await service.getMenus(restaurantGuid, query ?? {});
      // service.getMenus returns the raw MenusResponse (or undefined)
      const menus = (res?.menus ?? []) as ToastMenu[];
      return menus as any;
    },
    ...(options as any),
  });

  return q;
}
